<style lang="scss">
    .home-page {
        background: #f0f2f5 !important;
        padding: 5px 15px !important;
        display: block !important;
        &::-webkit-scrollbar {
            display: none;
        }

        .block {
            background: #fff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 20px;
            &-title {
                position: relative;
                line-height: 50px;
                padding-left: 20px;
                background: #f9f9f9;
                font-weight: bold;
                font-size: 16px;
                color: rgb(102, 102, 102);
                border-bottom: 1px solid #e9e9e9;
            }

            &-right {
                font-size: inherit;
                font-weight: normal;
                position: absolute;
                top: 50%;
                right: 20px;
                transform: translateY(-50%);
            }
        }

        .resource {
            display: flex;
            align-items: stretch;
            padding: 40px 0;
            &-line {
                width: 1px;
                background: #e9e9e9;

            }
            &-content {
                flex: 1;
                text-align: center;
                padding: 20px 0;

                .title {
                    font-size: 14px;
                    line-height: 20px;
                    color: #999;
                }
                .assist {
                    font-size: 28px;
                    line-height: 40px;
                }
            }
        }

        .canvas-panel {
            position: relative;
            height: 570px;
            display: flex;
            align-items: stretch;
            justify-content: center;
            .chart {
                width: 50%;
                min-width: 960px;

                &-empty {
                    position: absolute;
                    z-index: 100;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
</style>

<template>
    <div class="home-page">
        <div class="block">
            <p class="block-title">{{currDate}}</p>

            <section class="resource">
                <div class="resource-content">
                    <p class="title">总文件量</p>
                    <p class="assist" style="color: #F59A23">{{param.totalCount}}</p>
                </div>
                <div class="resource-line"></div>
                <div class="resource-content">
                    <p class="title">今日更新量</p>
                    <p class="assist" style="color: #FF7A8C">{{param.addCount}}</p>
                </div>
                <div class="resource-line"></div>
                <div class="resource-content">
                    <p class="title">今日浏览量</p>
                    <p class="assist" style="color: #73A0FA">{{param.readCount}}</p>
                </div>
                <div class="resource-line"></div>
                <div class="resource-content">
                    <p class="title">评论量</p>
                    <p class="assist" style="color: #C280FF">{{param.commentCount}}</p>
                </div>
                <div class="resource-line"></div>
                <div class="resource-content">
                    <p class="title">招聘量</p>
                    <p class="assist" style="color: #CC626E">{{param.recruitCount}}</p>
                </div>
                <div class="resource-content">
                    <p class="title">视频量</p>
                    <p class="assist" style="color: #F59A23">{{param.videoCount}}</p>
                </div>
                <div class="resource-content">
                    <p class="title">广告</p>
                    <p class="assist" style="color: #F59A23">{{param.advertisementCount}}</p>
                </div>
            </section>
        </div>

        <div class="block">
            <p class="block-title">
                纯销统计
                <span class="block-right">
                    <el-date-picker v-model="value" type="daterange" unlink-panels size="small" @change="loadStorage" value-format="yyyy-MM-dd"
                                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
    </el-date-picker>
                </span>
            </p>

            <div class="canvas-panel">
                <div class="chart" id="home-chart1"></div>
                <div v-show="valueShow" class="chart chart-empty">暂无数据</div>
            </div>
        </div>

        <div class="block">
            <p class="block-title">
                日志统计
                <span class="block-right">
                    <el-date-picker v-model="value1" type="daterange" unlink-panels size="small" @change="loadLog" value-format="yyyy-MM-dd"
                                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                </span>
            </p>

            <div class="canvas-panel">
                <div class="chart" id="home-chart2"></div>
                <div v-show="value1Show" class="chart chart-empty">暂无数据</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currDate:new Date().Format('yyyy年MM月dd日'),
                param: {
                    totalCount: 0,
                    addCount: 0,
                    readCount: 0,
                    commentCount: 0,
                    recruitCount: 0,
                    videoCount: 0,
                    advertisementCount: 0,
                },
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                },
                value: null,
                valueShow: false,
                value1: null,
                value1Show: false,
            }
        },
        created() {
             this.$api.get('sys/mainIndex/queryArticalTotalCount').then(res => {
                 this.param.totalCount = res.data
             })
             this.$api.get('sys/mainIndex/queryArticalAddCountForToday').then(res => {
                 this.param.addCount = res.data
             })
             this.$api.get('sys/mainIndex/queryArticalReadCountForToday').then(res => {
                 this.param.readCount = res.data
             })
             this.$api.get('sys/mainIndex/queryArticalCommentCount').then(res => {
                 this.param.commentCount = res.data
             })
             this.$api.get('sys/mainIndex/queryArticalRecruitCount').then(res => {
                 this.param.recruitCount = res.data
             })
            this.$api.get('sys/mainIndex/queryArticalVideoCount').then(res => {
                this.param.videoCount = res.data
            })
            this.$api.get('sys/mainIndex/queryAdvertisementCount').then(res => {
                this.param.advertisementCount = res.data
            })
        },
        mounted() {
            this.loadStorage()
            this.loadLog()
        },
        methods: {
            loadStorage() {
                const param = {}
                if (this.value) {
                    param.dateStart = this.value[0]
                    param.dateEnd = this.value[1]
                }
                // this.$api.post('sys/mainIndex/queryManageSubejctSaleAmount', param).then(res => {
                //     if (res.length > 0) {
                //         this.$help.renderArea('home-chart1', res.map(item => ({
                //             name: item.manageSubjectName,
                //             value: item.saleAmount
                //         })))
                //         this.valueShow = false
                //     } else {
                //         this.valueShow = true
                //     }
                // })
            },
            loadLog() {
                const param = {}
                if (this.value1) {
                    param.dateStart = this.value1[0]
                    param.dateEnd = this.value1[1]
                }
                // this.$api.post('sys/mainIndex/queryManageSubejctWorkLog', param).then(res => {
                //     if (res.length > 0) {
                //         this.$help.renderArea('home-chart2', res.map(item => ({
                //             name: item.manageSubjectName,
                //             value: item.workLogCount
                //         })))
                //         this.value1Show = false
                //     } else {
                //         this.value1Show = true
                //     }
                // })
            },
        }
    }
</script>